import { render, staticRenderFns } from "./AdministrableDropdown.vue?vue&type=template&id=70083da2&scoped=true"
import script from "./AdministrableDropdown.vue?vue&type=script&lang=js"
export * from "./AdministrableDropdown.vue?vue&type=script&lang=js"
import style0 from "./AdministrableDropdown.vue?vue&type=style&index=0&id=70083da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70083da2",
  null
  
)

export default component.exports